import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FaChevronRight } from 'react-icons/fa';

const SUB_TONE_CLASSES = {
	up: 'tw:text-ok',
	down: 'tw:text-danger',
	neutral: 'tw:text-ink-2',
};

// Tailwind's content scanner needs literal class strings, not interpolated
// `tw:bg-cat-${n}` — keep one static entry per category here instead.
const CAT_CLASSES = {
	1: 'tw:bg-cat-1',
	2: 'tw:bg-cat-2',
	3: 'tw:bg-cat-3',
	4: 'tw:bg-cat-4',
};

/**
 * KPI tile from the Inicio handoff spec: category-colored icon chip, uppercase
 * label, big mono value, tone-colored sub-line. No sparkline — this codebase
 * has no clean per-tile historical time series to plot one from.
 */
function Tile({ label, value, sub, subTone = 'neutral', icon, catColor, onClick }) {
	return (
		<button
			type='button'
			onClick={onClick}
			className='tw:group tw:flex tw:flex-col tw:gap-1 tw:p-[18px] tw:bg-surface tw:border tw:border-border tw:rounded-panel tw:text-left tw:transition-[border-color] tw:duration-150 tw:hover:border-ink-3'
		>
			<span className='tw:flex tw:items-center tw:gap-2'>
				<span
					className={classnames(
						'tw:w-6 tw:h-6 tw:rounded-token tw:flex tw:items-center tw:justify-center tw:text-[13px] tw:text-white',
						CAT_CLASSES[catColor],
					)}
				>
					{icon}
				</span>
				<span className='tw:flex-1 tw:min-w-0 tw:text-[11px] tw:font-semibold tw:uppercase tw:tracking-[0.06em] tw:text-ink-3'>
					{label}
				</span>
				<FaChevronRight
					size={11}
					className='tw:shrink-0 tw:ml-auto tw:text-ink-3 tw:opacity-0 tw:transition-[opacity,transform] tw:duration-150 tw:group-hover:opacity-100 tw:group-hover:translate-x-0.5'
				/>
			</span>
			<span className='tw:mt-1 tw:font-mono tw:text-[28px] tw:font-semibold tw:tracking-[-0.02em] tw:text-ink-0 tw:tabular-nums'>
				{value}
			</span>
			{sub && <span className={classnames('tw:text-[12px]', SUB_TONE_CLASSES[subTone])}>{sub}</span>}
		</button>
	);
}

Tile.propTypes = {
	label: PropTypes.node.isRequired,
	value: PropTypes.node.isRequired,
	sub: PropTypes.node,
	subTone: PropTypes.oneOf(['up', 'down', 'neutral']),
	icon: PropTypes.node,
	catColor: PropTypes.oneOf([1, 2, 3, 4]).isRequired,
	onClick: PropTypes.func,
};

export default Tile;
